import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'reactstrap';

import './RefreshButton.scss';

const DEFAULT_COLOR = 'primary';

const RefreshButton = (props) => {
  const {
    color,
    loading,
    onClick,
  } = props;

  return (
    <div className="blu-refresh-btn">
      <Button
        color={color}
        onClick={onClick}
      >
        {!loading && (
          <React.Fragment>
            <i className="fas fa-redo fa-lg" />
            &nbsp;&nbsp;
            Refresh
          </React.Fragment>
        )}

        {loading && (
          <span>
            ...
          </span>
        )}

      </Button>
    </div>
  );
};

RefreshButton.propTypes = {
  color: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
};

RefreshButton.defaultProps = {
  color: DEFAULT_COLOR,
  loading: false,
  onClick: () => {},
};

export default RefreshButton;
